import { AlertQuestion } from './alert-question';

export type AlertQuestionGroup = (AlertQuestion)[] | null;

